<script setup lang="ts">
import Toast from 'primevue/toast'
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-vue-next'
import '@/assets/css/toast.css'
</script>

<template>
  <Toast position="bottom-center" class="font-sans" appendTo="body">
    <template #container="slotProps">
      <div class="custom-toast cursor-pointer animate-in fade-in zoom-in-95 duration-200" :class="slotProps.message.severity" @click="slotProps.closeCallback">
        <div class="custom-toast-layout">
          <div class="flex-shrink-0">
            <CheckCircle2 v-if="slotProps.message.severity === 'success'" class="w-6 h-6 text-emerald-500" />
            <XCircle v-else-if="slotProps.message.severity === 'error'" class="w-6 h-6 text-rose-500" />
            <AlertTriangle v-else-if="slotProps.message.severity === 'warn'" class="w-6 h-6 text-amber-500" />
            <Info v-else class="w-6 h-6 text-sky-500" />
          </div>
          <div class="custom-toast-text">
            <div class="custom-toast-summary">{{ slotProps.message.summary }}</div>
            <div v-if="slotProps.message.detail" class="custom-toast-detail">{{ slotProps.message.detail }}</div>
          </div>
        </div>
      </div>
    </template>
  </Toast>

  <Toast position="bottom-center" group="noLinkBookie" class="font-sans" appendTo="body">
    <template #container="slotProps">
      <div class="custom-toast info cursor-pointer animate-in fade-in zoom-in-95 duration-200" @click="slotProps.closeCallback">
        <div class="custom-toast-layout">
          <div class="flex-shrink-0">
            <Info class="w-6 h-6 text-sky-500" />
          </div>
          <div class="custom-toast-text">
            <div class="custom-toast-summary">{{ slotProps.message.summary }}</div>
            <div v-if="slotProps.message.detail" class="custom-toast-detail">{{ slotProps.message.detail }}</div>
          </div>
        </div>
      </div>
    </template>
  </Toast>
</template>
